/*
 * newsbot - forked from autobrr
 */

import { UserCircleIcon } from "@heroicons/react/24/outline";

import { useAuth } from "@contexts/AuthContext";
import { IntegrationTokens } from "./IntegrationTokens";

export default function AccountSettings() {
  const { user, profile, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="divide-y divide-gray-200 dark:divide-gray-700 lg:col-span-9">
        <div className="py-6 px-4 sm:p-6 lg:pb-8">
          <div className="flex justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="divide-y divide-gray-200 dark:divide-gray-700 lg:col-span-9">
      <div className="py-6 px-4 sm:p-6 lg:pb-8">
        <div>
          <h2 className="text-lg leading-6 font-medium text-gray-900 dark:text-white">
            Account
          </h2>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Your account information
          </p>
        </div>

        <div className="mt-6">
          <div className="bg-gray-50 dark:bg-gray-900 rounded-lg p-6">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <UserCircleIcon className="h-16 w-16 text-gray-400 dark:text-gray-500" />
              </div>
              <div className="ml-6">
                <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                  {profile?.display_name || user?.email?.split("@")[0] || "User"}
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  {user?.email}
                </p>
                {profile?.role && (
                  <span className="mt-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                    {profile.role}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6">
          <h3 className="text-sm font-medium text-gray-900 dark:text-white">
            Account Details
          </h3>
          <dl className="mt-4 space-y-4">
            <div className="flex justify-between">
              <dt className="text-sm text-gray-500 dark:text-gray-400">Email</dt>
              <dd className="text-sm text-gray-900 dark:text-white">{user?.email || "-"}</dd>
            </div>
            <div className="flex justify-between">
              <dt className="text-sm text-gray-500 dark:text-gray-400">Display Name</dt>
              <dd className="text-sm text-gray-900 dark:text-white">{profile?.display_name || "-"}</dd>
            </div>
            <div className="flex justify-between">
              <dt className="text-sm text-gray-500 dark:text-gray-400">Role</dt>
              <dd className="text-sm text-gray-900 dark:text-white capitalize">{profile?.role || "-"}</dd>
            </div>
            <div className="flex justify-between">
              <dt className="text-sm text-gray-500 dark:text-gray-400">User ID</dt>
              <dd className="text-sm text-gray-900 dark:text-white font-mono text-xs">{user?.id || "-"}</dd>
            </div>
          </dl>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Account settings are managed through Supabase Auth. Contact an administrator to change your role or email.
          </p>
        </div>

        <IntegrationTokens />
      </div>
    </div>
  );
}
